// removed by extract-text-webpack-plugin
module.exports = {"command":"undo-redo__command___pbS13","disabled":"undo-redo__disabled___34Z4S","svgPath":"undo-redo__svgPath___fGljv","container":"undo-redo__container___3PDpB"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/undo-redo.css
// module id = 846
// module chunks = 0